<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款对象：</span>
        </div>
        <el-input v-model="formData.refundObj" size="small" style="width: 280px" disabled>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费项名称：</span>
        </div>
        <el-input  v-model="formData.paymentItemName" size="small" style="width: 280px" disabled>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费模式：</span>
        </div>
        <el-input  v-model="formData.chargeMode" size="small" style="width: 280px" disabled>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费类型：</span>
        </div>
        <el-input  v-model="formData.chargeType" size="small" style="width: 280px" disabled>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单金额：</span>
        </div>
        <el-input v-model="formData.billAmount" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应退金额：</span>
        </div>
        <el-input v-model="formData.refundAmount" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">实退金额：</span>
        </div>
        <el-input v-model="formData.actualRefundAmount" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">经办人：</span>
        </div>
        <el-input v-model="formData.operator" size="small" style="width: 280px" >
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款时间：</span>
        </div>
        <el-date-picker v-model="formData.refundTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="退款时间" size="small" style="width: 280px"></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" >
        </el-input>
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/CustomPayment";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
export default {
  components: {
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "refund-management-confirm",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "退款管理"
        }
      ],
      mainTitle: "确认退款",
      subheading: "",
      formData: {}
    };
  },
  created() {
    this.getRefundManagementByCode();
  },
  methods: {
    getRefundManagementByCode() {
      this.$axios
        .get(`${api.getRefundManagementByCode}/${this.$route.params.id}`, {})
        .then(res => {
          this.formData = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    toManagePage() {
      this.$router.push({
        name: "refund-management"
      });
    },
    confirm() {
      if (!this.formData.actualRefundAmount) {
        nError("请输入实退金额");
        return false;
      }
      if (!this.formData.operator) {
        nError("请输入经办人");
        return false;
      }
      if (!this.formData.refundTime) {
        nError("请选择退款时间");
        return false;
      }
      this.formData.code = this.$route.params.id;

      if (this.formData.actualRefundAmount !== this.formData.refundAmount) {
        this.$confirm("应退金额和实退金额不一致，是否确认？", "提示")
          .then(() => {
            this.$axios
              .post(api.confirmRefundBill, this.formData)
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess("修改成功");
                  this.toManagePage();
                }
              })
              .catch(errorHandler("确认退款失败"));
          })
          .catch(() => {
            console.log("取消确认");
          });
      } else {
        this.$axios
          .post(api.confirmRefundBill, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess("修改成功");
              this.toManagePage();
            }
          })
          .catch(errorHandler("确认退款失败"));
      }
    },
    cancel() {
      this.toManagePage();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/RefundManagement/RefundManagementConfirm.vue